import { jsx } from "react/jsx-runtime";
import DataArrayIcon from "@mui/icons-material/DataArray";
import { validateTidalLicense } from "../../base/index.js";
function DataArray(props) {
  return /* @__PURE__ */ jsx(
    DataArrayIcon,
    {
      "data-testid": "DataArray",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "DataArray",
      "data-tidal-icon-meta": "folders,notes,lists"
    }
  );
}
DataArray.tidalIconMeta = {
  categories: "folders,notes,lists",
  name: "DataArray"
};
validateTidalLicense();
export {
  DataArray
};
//# sourceMappingURL=DataArray.js.map
